import React from 'react';
import { useState } from 'react';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { useDict, useLanguageUpdate } from '../../../contexts/LanguageContext';
import ForgotPasswordForm from './ForgotPasswordForm';
import CustomSwitch from '../../../components/CustomSwitch';

const ForgotPassword = () => {
    const dict = useDict();
    const toggleLanguage = useLanguageUpdate();
    const [language, setLanguage] = useState(localStorage.getItem('language') === 'th');

    const handleChange = (checked) => {
        setLanguage(checked);
        toggleLanguage(checked ? 'th' : 'en');
    };

    return (
        <>
            <div className="account account--photo">
                <div className="account__wrapper">
                    <div className="account__card">
                        <div>
                            <div className="text-right">
                                <CustomSwitch
                                    checked={language}
                                    onChange={handleChange}
                                    width={65}
                                    height={35}
                                    className="language-switch"
                                    leftText="EN"
                                    rightText="TH"
                                    switchOffClassName="switch-off"
                                    switchOnClassName="switch-on"
                                />
                            </div>
                            <h3 className="account__title">
                                <span className="account__logo">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className="auth-logo"
                                    />
                                </span>
                            </h3>
                        </div>
                        <ForgotPasswordForm />
                        <div className="account__or_divide">
                            <div className="regulated-by-text">
                                {dict.regulatedByText}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default ForgotPassword;
